import LanguageSwitch from './js/LanguageSwitch';

export default LanguageSwitch;
